import { CallStatusType, CallStatuses } from 'contexts/LiveKitContext';

export const getCallStatusText = (callStatus: CallStatusType) => {
    switch (callStatus) {
        case CallStatuses.INCOMING:
            return 'Incoming Call...';
        case CallStatuses.IN_PROGRESS:
            return 'Call in Progress';
        case CallStatuses.MANUAL_CALLBACK:
            return 'Calling...';
        case CallStatuses.READY:
            return 'Ready for Calls';
        case CallStatuses.ERROR:
            return 'Error with Twilio';
        case CallStatuses.INITIALIZING:
            return 'Initializing...';
        default:
            return 'Offline';
    }
};
